import React, { useState, useEffect, useRef, useContext } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { motion } from "framer-motion";
import VisibilitySensor from "react-visibility-sensor";
import { Context } from "../../context";
import classes from "./Project.module.css";
import Container from "react-bootstrap/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop, faServer } from "@fortawesome/free-solid-svg-icons";

const ProjectDetailsGallery = ({ data, caption, type, showText }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const lightboxRef = useRef();
  const { debug, lang } = useContext(Context);

  const CloseButton = ({ onClick }) => (
    <button className="lightbox-close-button" onClick={onClick}>
      Chiudi
    </button>
  );

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };

  const openLightbox = (index) => {
    setLightboxOpen(true);
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxIndex(0);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (lightboxRef.current && !lightboxRef.current.contains(event.target)) {
        closeLightbox();
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <Container fluid className="text-center pb-5 pt-0">
        <Container fluid className={`${classes.projectGalleryContainer}`}>
          {showText && data && data.length > 0 ? (
            <VisibilitySensor
              onChange={changeVisibility}
              partialVisibility
              delayedCall
            >
              <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{
                  opacity: isVisible ? 1 : 0,
                  y: isVisible ? 0 : 20,
                }}
                transition={{ duration: 0.4, delay: 0.2 }}
                className="text-7 text-dark w-100 align-self-center lh-base mb-1 mt-5"
              >
                {" "}
                Screenshot
              </motion.p>
            </VisibilitySensor>
          ) : null}

          {data && data.length > 0 ? (
            <>
              <p
                className={
                  type === "frontend" ? classes.frontendText : classes.cmsText
                }
              >
                {type === "frontend" ? (
                  <p className={classes.skillTitle}>
                    <FontAwesomeIcon icon={faDesktop} /> &nbsp;Frontend
                  </p>
                ) : (
                  <p className={classes.skillTitle}>
                    <FontAwesomeIcon icon={faServer} /> &nbsp;Backend
                  </p>
                )}
              </p>
              <div className={classes.projectGallery}>
                {data.map((img, index) => (
                  <div
                    key={index}
                    className={`${classes.projectGalleryItem} col-12 col-md-4`}
                  >
                    <img
                      src={img}
                      alt="gallery"
                      className={classes.projectGalleryImg}
                      onClick={() => openLightbox(index)}
                    />
                    <p className={classes.caption}>{caption[index]}</p>
                  </div>
                ))}
              </div>
            </>
          ) : null}
        </Container>
      </Container>

      {lightboxOpen && (
        <Lightbox
          ref={lightboxRef}
          mainSrc={data[lightboxIndex]}
          nextSrc={data[(lightboxIndex + 1) % data.length]}
          prevSrc={data[(lightboxIndex + data.length - 1) % data.length]}
          onCloseRequest={() => setLightboxOpen(false)}
          onMovePrevRequest={() =>
            setLightboxIndex((lightboxIndex + data.length - 1) % data.length)
          }
          onMoveNextRequest={() =>
            setLightboxIndex((lightboxIndex + 1) % data.length)
          }
          closeButtonReplacesBottomButtons={true}
          closeComponent={CloseButton}
        />
      )}
      <script src="/vendor/jquery/jquery.min.js"></script>
      <script src="/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
      <script src="/js/theme.js"></script>
    </>
  );
};

export default ProjectDetailsGallery;
